import {
  IframelyProvider,
  PageTitleProvider,
  Site,
  SiteContext,
} from "@equiem/web-ng-lib";
import React, { PropsWithChildren, useContext, useMemo } from "react";
import { IconContext } from "react-icons";
import { NewRelic } from "../components/newrelic/NewRelic";
import { SiteHead } from "../components/SiteHead";
import { useSiteVmsSettingsQuery } from "../generated/gateway-client";
import { Session } from "@equiem/web-ng-lib";

const VmsSiteSettingsEnricher: React.FC<PropsWithChildren<{
  site: SiteContext;
}>> = ({ site, children }) => {
  const session = useContext(Session);
  const authenticatedClient = session.side === "client" ? session.authenticatedClient : undefined;

  const { data } = useSiteVmsSettingsQuery({
    variables: { uuid: site.uuid },
    skip: site.uuid === "" || authenticatedClient == null || !session.authenticated,
    client: authenticatedClient,
  });

  const dealActivationEnabled = data?.destination?.vmsSettings?.dealActivationEnabled ?? site.vmsSiteSettings.dealActivationEnabled;

  const enrichedSite = useMemo(() => ({
    ...site,
    vmsSiteSettings: {
      dealActivationEnabled,
    },
  }), [site, dealActivationEnabled]);

  return <Site.Provider value={enrichedSite}>{children}</Site.Provider>;
};

export const SiteProviders: React.FC<PropsWithChildren<{
  site: SiteContext;
}>> = ({ site, children }) => (
  <VmsSiteSettingsEnricher site={site}>
    <PageTitleProvider>
      <NewRelic />
      <IconContext.Provider
        value={{
          size: "1em",
          style: { verticalAlign: "middle", marginBottom: ".15em" },
        }}
      >
        <IframelyProvider>
          <SiteHead />
          {children}
        </IframelyProvider>
      </IconContext.Provider>
    </PageTitleProvider>
  </VmsSiteSettingsEnricher>
);
